const shop = {
  state: {
    name: ""
  },

  mutations: {
    SET_NAME: (state, val) => {
      state.name = val;
    }
  },

  actions: {
    setName({ commit }, val) {
      commit("SET_NAME", val);
    }
  },
  getters: {
    getName: state => {
      return state.name;
    }
  }
};

export default shop;
